module.exports = __webpack_public_path__ + "static/img/WB740-PF_A.7216e4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WB740-PF_A.jpg
// module id = GrTr
// module chunks = 0